export const getLanguageFormat = (language: string): string => {
  const index = language.indexOf('_');
  if (index !== -1) {
    return language.slice(0, index);
  } else {
    return language;
  }
};
